import { useState } from "react";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Droplets, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("admin@carwash.com");
  const [password, setPassword] = useState("admin123");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav(loc.state?.from || "/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] grain flex items-center justify-center p-4 relative">
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, rgba(0,122,255,0.15) 0%, transparent 40%), radial-gradient(circle at 80% 70%, rgba(0,122,255,0.08) 0%, transparent 45%)",
        }}
      />
      <div className="w-full max-w-md relative z-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-[#007AFF] flex items-center justify-center">
            <Droplets className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display font-black text-lg tracking-tighter uppercase leading-tight">
              Car Wash <span className="text-[#007AFF]">PM</span>
            </div>
            <div className="font-mono-tab text-[10px] tracking-[0.2em] text-[#737373] uppercase">
              Maintenance Control
            </div>
          </div>
        </div>

        <div className="border border-white/10 bg-[#121212] p-8">
          <div className="font-mono-tab text-[10px] tracking-[0.2em] uppercase text-[#737373] mb-2">
            Access Terminal
          </div>
          <h1 className="font-display text-3xl font-black tracking-tighter uppercase mb-6">
            Sign <span className="text-[#007AFF]">In</span>
          </h1>

          <form onSubmit={submit} className="space-y-5">
            <label className="block">
              <div className="font-mono-tab text-[10px] tracking-[0.2em] uppercase text-[#737373] mb-1.5">
                Email
              </div>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border border-white/20 px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#007AFF] focus:ring-1 focus:ring-[#007AFF]"
              />
            </label>

            <label className="block">
              <div className="font-mono-tab text-[10px] tracking-[0.2em] uppercase text-[#737373] mb-1.5">
                Password
              </div>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border border-white/20 px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#007AFF] focus:ring-1 focus:ring-[#007AFF]"
              />
            </label>

            {error && (
              <div
                data-testid="login-error"
                className="border border-[#FF3B30]/40 bg-[#FF3B30]/10 text-[#FF3B30] px-3 py-2 text-xs"
              >
                {error}
              </div>
            )}

            <button
              data-testid="login-submit"
              type="submit"
              disabled={submitting}
              className="w-full px-5 py-2.5 bg-[#007AFF] hover:bg-[#3395FF] disabled:opacity-50 text-white text-sm font-medium tracking-tight flex items-center justify-center gap-2"
            >
              {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
              Sign In
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-white/10 text-center text-xs text-[#A3A3A3]">
            Need an account?{" "}
            <Link data-testid="link-register" to="/register" className="text-[#007AFF] hover:text-[#3395FF]">
              Register
            </Link>
          </div>
        </div>

        <div className="mt-6 text-[10px] font-mono-tab tracking-[0.15em] uppercase text-[#737373] text-center">
          Demo · admin@carwash.com / admin123
        </div>
      </div>
    </div>
  );
}
